import { useState } from "react";
import { handleRangeFromFilter } from "../../utils";

export const useStockProfit = (
  product,
  defaultFilter = undefined,
  isRefreshed = false,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState(defaultFilter || "All time");
  const [outCount, setOutCount] = useState(0);
  const [inCount, setInCount] = useState(0);
  const [totalIn, setTotalIn] = useState(0);
  const [totalOut, setTotalOut] = useState(0);
  const [totalSalePrice, setTotalSalePrice] = useState(0);

  const handleStockProfit = async () => {
    setIsLoading(true);

    const { start, end } = handleRangeFromFilter(filter);

    const allOrdersQuery =
      filter == "All time"
        ? product.getOrdersByDate(undefined, undefined)
        : product.getOrdersByDate(start, end);

    const allInvQuery =
      filter == "All time"
        ? product.getInvByDate(undefined, undefined)
        : product.getInvByDate(start, end);

    const allOrders = await allOrdersQuery.unsafeFetchRaw();
    const allInv = await allInvQuery.unsafeFetchRaw();

    const allData = [...allOrders, ...allInv];

    let quantityIn = 0;
    let quantityOut = 0;
    let incoming = 0;
    let outgoing = 0;
    let saleAmount = 0;

    allData.forEach((item) => {
      let discount = item?.discount || 0;

      if (item.type == "sales") {
        incoming +=
          (item.selling_price - (item.cost_price || 0) - discount) *
          item.quantity;
        quantityOut += item.is_secondary_unit
          ? item.quantity / (item.unit_conversion || 1)
          : item.quantity;

        saleAmount += (item.selling_price - discount) * item.quantity;
      } else if (item.type == "expense") {
        outgoing += (item.cost_price - discount) * item.quantity;
        quantityIn += item.is_secondary_unit
          ? item.quantity / (item.unit_conversion || 1)
          : item.quantity;
      } else if (item.type == "in") {
        outgoing += item.price * item.quantity;
        quantityIn += item.quantity;
      }
    });

    setOutCount(quantityOut);
    setInCount(quantityIn);
    setTotalIn(incoming);
    setTotalOut(outgoing);
    setTotalSalePrice(saleAmount);

    setIsLoading(false);
  };

const handleFilterProfitTracker = async (startDate, endDate) => {
  let start;
  let end;

  if (startDate) {
    const s = new Date(startDate);
    s.setHours(0, 0, 0, 0);
    start = s.getTime();
  }

  if (endDate) {
    const e = new Date(endDate);
    e.setHours(23, 59, 59, 999);
    end = e.getTime();
  } else if (startDate) {
    const e = new Date(startDate);
    e.setHours(23, 59, 59, 999);
    end = e.getTime();
  }

  const [allOrders, allInv] = await Promise.all([
    product.getOrdersByDate(start, end).unsafeFetchRaw(),
    product.getInvByDate(start, end).unsafeFetchRaw(),
  ]);

  const allData = [...allOrders, ...allInv];

  let quantityOut = 0;
  let incoming = 0;
  let saleAmount = 0;

  allData.forEach((item) => {
    if (item?.type !== "sales") return;

    const sellingPrice = item?.selling_price || 0;
    const costPrice = item?.cost_price || 0;
    const quantity = item?.quantity || 0;
    const discount = item?.discount || 0;
    const unitConversion = item?.unit_conversion || 1;

    // Profit
    incoming += (sellingPrice - costPrice - discount) * quantity;

    // Quantity
    quantityOut += item?.is_secondary_unit
      ? quantity / (unitConversion || 1)
      : quantity;

    // Sales
    saleAmount += (sellingPrice - discount) * quantity;
  });

  setOutCount(quantityOut);
  setTotalIn(incoming);
  setTotalSalePrice(saleAmount);
};

  return {
    isLoading,
    outCount,
    inCount,
    totalIn,
    totalOut,
    totalSalePrice,
    handleStockProfit,
    handleFilterProfitTracker,
  };
};
